import React, { useEffect, useState } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
import { Sidebar, Menu, SubMenu, MenuItem } from "react-pro-sidebar";
import { useDispatch, useSelector } from "react-redux";
import { setCollapsed, setNavbarTabs } from "../../Pages/CommonAppRedux/Layout/layoutSlice";
import { admin, sidebarData } from "./SidebarData";
import "./sidebar.css";
import { IoIosArrowDropleftCircle, IoIosArrowDroprightCircle } from "react-icons/io";
import getCookie from "../../Utils/Cookies/getCookie";
import { logout } from "../../Pages/CommonAppRedux/Auth/thunk";
import { errorFunction, successFunction } from "../Alert/Alert";
import { setSystemSelected } from "../../Pages/CommonAppRedux/SystemSelection/systemSelectionSlice";
import logo from "../../assets/iBISAP.png";
import CreateAlert from "../Alert/CreateAlert";
import { FaRegUserCircle } from "react-icons/fa";
import { RiShoppingCartLine } from "react-icons/ri";

const CrmSidebar = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const permissionApi = useSelector((state) => state.auth.permissions);
  const isSuperuser = true;
  const { collapsed, showModal } = useSelector((state) => state.layout);
  const [search, setSearch] = useState("");
  const [toggled, setToggled] = useState(false);
  const [disablePointerEvents, setDisablePointerEvents] = useState(false);
  const collapseicon = useSelector((state) => state.layout.collapseIcon);
  const user = useSelector((state) => state.auth.user);

  const capitalizedUserName = user?.username?.charAt(0).toUpperCase() + user?.username?.slice(1);
  const photo = useSelector((state) => state.auth.photo);
  const [open, setOpen] = useState();
  const [childMenuOpen, setChildMenuOpen] = useState();
  const [remove, setRemove] = useState(false);
  const [showAlert, setShowAlert] = useState(false);

  const handleOpenSubMenu = (key) => {
    if (open === key) {
      setOpen(undefined);
    } else {
      setOpen(key);
    }
  };

  const handleChildMenuOpen = (key) => {
    if (childMenuOpen === key) {
      setChildMenuOpen(undefined);
    } else {
      setChildMenuOpen(key);
    }
  };

  const handleMenuClick = () => {
    setDisablePointerEvents(true);
    setTimeout(() => {
      setDisablePointerEvents(false);
    }, 250);
  };

  const menuItemStyles = {
    root: {
      fontSize: "14px",
      fontWeight: 400,
      // padding: "0px 0px 0px 0px",
      transition: !collapsed ? "all 0.1s ease-out" : "none",
    },
    icon: {
      margin: "0px",
    },
    SubMenuExpandIcon: {
      color: "#b6b7b9",
      // color: "red !important",
      // color: "red !important",
    },
    button: ({ level, active, disabled }) => {
      if (level === 0) {
        return {
          padding: "0px 10px 0 0 ",
          // color: "red !important",
          // background-color: red !important,
          "&:hover": {
            backgroundColor: "var(--blue-primary)",
            color: "white !important",
            borderRadius: "10px",
            transition: !collapsed ? "all 0.1s ease-in" : "none",
          },
        };
      }
      if (level === 1) {
        return {
          color: "rgba(36, 34, 32, 0.86)",
          height: "max-content",
          // width: "200%",
          "&:hover": {
            backgroundColor: "var(--blue-primary)",
            color: "white !important",
            marginLeft: collapsed ? "0px" : "20px",
            borderRadius: collapsed ? "5px" : "10px",
            transition: !collapsed ? "all 0.1s ease-in" : "none",
          },
        };
      }
      if (level === 2) {
        return {
          color: "rgba(36, 34, 32, 0.56)",
          marginLeft: "10px",
          height: "50px",
          "&:hover": {
            backgroundColor: "var(--blue-primary)",
            color: "white !important",
            marginLeft: collapsed ? "0px" : "20px",
            borderRadius: collapsed ? "5px" : "10px",
            transition: !collapsed ? "all 0.1s ease-in" : "none",
          },
        };
      }
    },
    label: ({ open, level }) => {
      if (level === 0) {
        return {
          padding: "5px",
        };
      }
      if (level === 1) {
        return {
          padding: collapsed ? "10px 5px" : "10px 20px",
          "&:hover": {
            padding: collapsed ? "10px 0px" : "10px 0px",
          },
        };
      }
    },
  };

  const handleLogout = () => {
    if (!remove) {
      setShowAlert(true);
    } else {
      const token = getCookie("refresh");
      if (token) {
        dispatch(logout(token))
          .unwrap()
          .then(() => {
            successFunction("Logged out successfully.");
            dispatch(setSystemSelected(""));
            history.push("/");
          })
          .catch((error) => errorFunction("Failed to logout."));
      }
      setShowAlert(false);
      setRemove(false);
    }
  };

  useEffect(() => {
    if (remove) {
      handleLogout();
    }
  }, [remove]);

  useEffect(() => {
    const numberInputs = document.querySelectorAll('input[type="number"]');
    numberInputs.forEach((input) => {
      input.addEventListener("wheel", function (event) {
        event.preventDefault();
      });
    });
  });

  const handleMenuItemClick = (sub) => {
    dispatch(setNavbarTabs(sub));
  };

  // Modified sidebarData with collapsedLabel for specific menus
  const modifiedSidebarData = sidebarData.map((item) => {
    if (item.key === "sales") {
      return {
        ...item,
        // collapsedLabel: "sale",
        // alwaysOpenChildren: true,
      };
    }
    if (item.key === "item") {
      return {
        ...item,
        // collapsedLabel: "item",
      };
    }
    return item;
  });
  const modifiedSidebarAdminData = admin.map((item) => {
    if (item.menu === "Setting") {
      return {
        ...item,
        // collapsedLabel: "sale",
        // alwaysOpenChildren: true,
      };
    }

    return item;
  });

  const renderMenuItems = (data) => {
    return data?.map((side) => {
      const { menu, sub_menu, icon, link, permissions, key, collapsedLabel, alwaysOpenChildren } = side;
      const showMenu = permissions?.some((element) => permissionApi?.indexOf(element) !== -1);

      if (!showMenu && !isSuperuser) return null;

      if (sub_menu) {
        return (
          <SubMenu
            key={key}
            label={collapsed ? collapsedLabel || null : menu}
            icon={icon}
            onClick={() => handleOpenSubMenu(key)}
            open={alwaysOpenChildren || open === key}
            style={{
              margin: "0px 10px 0px 10px",
              position: "relative",
              zIndex: "1100",

              height: "40px",
              justifyContent: "center",
              overflow: "visible",
              ...(collapsed && {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "40px",
              }),
            }}
          >
            {sub_menu.map((sub) => {
              const { link, name, permissions, childKey, child_menu } = sub;
              const showSubMenu = permissions?.some((element) => permissionApi?.indexOf(element) !== -1) || isSuperuser;

              if (child_menu) {
                return (
                  <SubMenu
                    key={childKey}
                    label={name}
                    onClick={() => handleChildMenuOpen(childKey)}
                    open={alwaysOpenChildren || childMenuOpen === childKey}
                  >
                    {child_menu.map((child) => {
                      const showChild =
                        child.permissions?.some((el) => permissionApi?.indexOf(el) !== -1) || isSuperuser;
                      return (
                        showChild && (
                          <MenuItem
                            key={child.name}
                            active={location.pathname === child.link}
                            component={<Link to={child.link} />}
                            onClick={() => handleMenuItemClick(child)}
                            style={{
                              height: "30px",
                              justifyContent: "center",
                            }}
                          >
                            {child.name}
                          </MenuItem>
                        )
                      );
                    })}
                  </SubMenu>
                );
              }
              return (
                showSubMenu && (
                  <MenuItem
                    key={name}
                    active={location.pathname === link}
                    component={<Link to={link} />}
                    onClick={() => handleMenuItemClick(sub)}
                    style={{
                      height: "40px",
                      justifyContent: "center",
                      // width: "100%",
                    }}
                  >
                    {name}
                  </MenuItem>
                )
              );
            })}
          </SubMenu>
        );
      }

      return (
        <MenuItem key={key} active={location.pathname === link} component={<Link to={link} />} icon={icon}>
          {menu}
        </MenuItem>
      );
    });
  };

  const renderSearchResults = () => {
    return modifiedSidebarData?.map((side) => {
      const { menu, sub_menu, icon, link, permissions, key } = side;
      const showMenu = permissions?.some((element) => permissionApi?.indexOf(element) !== -1);

      if (!showMenu && !isSuperuser) return null;

      const menuMatches = menu.toLowerCase().includes(search.toLowerCase());
      const subMenuMatches = sub_menu?.some(
        (sub) =>
          sub.name.toLowerCase().includes(search.toLowerCase()) ||
          sub.child_menu?.some((child) => child.name.toLowerCase().includes(search.toLowerCase()))
      );

      if (!menuMatches && !subMenuMatches) return null;

      if (sub_menu) {
        return (
          <SubMenu
            key={key}
            label={menu}
            icon={icon}
            onClick={() => handleOpenSubMenu(key)}
            open={true} // Force open during search
          >
            {sub_menu.map((sub) => {
              const showSub = sub.permissions?.some((el) => permissionApi?.indexOf(el) !== -1) || isSuperuser;
              const subMatches = sub.name.toLowerCase().includes(search.toLowerCase());
              const childMatches = sub.child_menu?.some((child) =>
                child.name.toLowerCase().includes(search.toLowerCase())
              );

              if (!subMatches && !childMatches) return null;

              if (sub.child_menu) {
                return (
                  <SubMenu
                    key={sub.childKey}
                    label={sub.name}
                    onClick={() => handleChildMenuOpen(sub.childKey)}
                    open={true} // Force open during search
                  >
                    {sub.child_menu.map((child) => {
                      const showChild =
                        child.permissions?.some((el) => permissionApi?.indexOf(el) !== -1) || isSuperuser;
                      const childMatch = child.name.toLowerCase().includes(search.toLowerCase());
                      return (
                        showChild &&
                        childMatch && (
                          <MenuItem
                            key={child.name}
                            active={location.pathname === child.link}
                            component={<Link to={child.link} />}
                            onClick={() => handleMenuItemClick(child)}
                          >
                            {child.name}
                          </MenuItem>
                        )
                      );
                    })}
                  </SubMenu>
                );
              }
              return (
                showSub &&
                subMatches && (
                  <MenuItem
                    key={sub.name}
                    active={location.pathname === sub.link}
                    component={<Link to={sub.link} />}
                    onClick={() => handleMenuItemClick(sub)}
                  >
                    {sub.name}
                  </MenuItem>
                )
              );
            })}
          </SubMenu>
        );
      }

      return (
        <MenuItem key={key} active={location.pathname === link} component={<Link to={link} />} icon={icon}>
          {menu}
        </MenuItem>
      );
    });
  };

  return (
    <>
      <div
        className={collapsed ? "collapsed-sidebar d-flex flex-column" : "sidebar d-flex flex-column"}
        style={{ position: "relative", height: "100vh", borderRightWidth: "none" }}
      >
        <div className="sidebar-header d-flex justify-content-between align-items-center">
          <Link to="/">
            {collapsed ? (
              <div className="logo-container collapsed">
                <img alt="logo" src={logo} />
              </div>
            ) : (
              <div className="logo-container">
                <img
                  alt="logo"
                  src={logo}
                  style={{
                    maxWidth: "100px",
                    height: "auto",
                    display: "block",
                    margin: "0 auto",
                  }}
                />
              </div>
            )}
          </Link>
          {collapseicon && (
            <button
              type="button"
              className={"collapse-btn"}
              disabled={showModal}
              onClick={() => {
                dispatch(setCollapsed());
              }}
            >
              {collapsed ? <IoIosArrowDroprightCircle /> : <IoIosArrowDropleftCircle />}
            </button>
          )}
        </div>
        {!collapsed ? (
          <Sidebar
            collapsedWidth="40px"
            className="sidebar h-100"
            collapsed={collapsed}
            toggled={toggled}
            breakPoint="md"
            transitionDuration={250}
            width="var(--sidebar-width)"
            rootStyles={{
              overflow: "auto",
              padding: "10px",
              backgroundColor: "white",
              [`.ps-sidebar-container`]: {
                backgroundColor: "white",
              },
            }}
          >
            <div className="d-flex flex-column h-100 justify-content-between">
              <div>
                <input
                  style={{
                    width: "100%",
                    minWidth: "200px",
                    border: "0px",
                    padding: "6px 10px",
                    outline: "none",
                    backgroundColor: "#F8F9FA",
                  }}
                  type="text"
                  value={search}
                  onChange={(e) => setSearch(e.target.value.trimStart())}
                  placeholder="Search..."
                  aria-label="Search..."
                  aria-describedby="basic-addon1"
                />
                <Menu menuItemStyles={menuItemStyles} transitionDuration={250}>
                  {search === "" ? renderMenuItems(modifiedSidebarData) : renderSearchResults()}
                </Menu>
              </div>

              {/* for setup */}
              <div>
                <div className={`sidebar-section-title ${collapsed ? "text-center" : "text-left"}`}>Setup</div>
                <Menu menuItemStyles={menuItemStyles} onClick={handleMenuClick} transitionDuration={250}>
                  {renderMenuItems(modifiedSidebarAdminData)}
                </Menu>
                <Menu menuItemStyles={menuItemStyles} onClick={handleMenuClick} transitionDuration={250}>
                  <SubMenu
                    onClick={() => handleOpenSubMenu("user")}
                    open={open === "user"}
                    label={capitalizedUserName}
                    icon={photo ? <img src={photo} height={20} /> : <FaRegUserCircle />}
                  >
                    <MenuItem
                      style={{ pointerEvents: disablePointerEvents ? "none" : "auto" }}
                      active={location.pathname === "/change-password"}
                      onClick={() => history.push("/change-password")}
                    >
                      Change Password
                    </MenuItem>
                    <MenuItem
                      style={{ pointerEvents: disablePointerEvents ? "none" : "auto" }}
                      onClick={() => handleLogout()}
                    >
                      Logout
                    </MenuItem>
                  </SubMenu>
                </Menu>
              </div>
            </div>
          </Sidebar>
        ) : (
          <Sidebar
            collapsedWidth="80px"
            className="h-100"
            collapsed={collapsed}
            breakPoint="md"
            rootStyles={{
              overflow: "auto",
              padding: "10px",
              backgroundColor: "white",
              borderRightStyle: "none",
              width: "var(--sidebar-width)",
              [`.ps-sidebar-container`]: {
                backgroundColor: "white",
              },
            }}
          >
            <Menu
              menuItemStyles={menuItemStyles}
              style={{
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {renderMenuItems(modifiedSidebarData)}
            </Menu>
          </Sidebar>
        )}
      </div>
      {showAlert && <CreateAlert showAlert={showAlert} setShowAlert={setShowAlert} setSubmit={setRemove} />}
    </>
  );
};

export default CrmSidebar;
